import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import ChainedBackend from 'i18next-chained-backend';
import HttpBackend from 'i18next-http-backend';
import resourcesToBackend from 'i18next-resources-to-backend';

import translationEN from './locales/enUS/translation.json';
import translationNL from './locales/nlNL/translation.json';
import translationDE from './locales/deDE/translation.json';
import baseURL from './utils/consts';

const resources = {
  en: { translation: translationEN },
  nl: { translation: translationNL },
  de: { translation: translationDE },
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .use(ChainedBackend)
  .init({
    backend: {
      backends: [HttpBackend, resourcesToBackend(resources)],
      backendOptions: [
        {
          loadPath: (lngs: string | string[]) => {
            const lng = Array.isArray(lngs) ? lngs[0] : lngs;
            return `${baseURL}/v2/translations?lang=${lng}&component=emdr-remote&project=psylaris-emdr-remote`;
          },
          crossDomain: true,
          allowMultiLoading: false,
        },
      ],
    },
    fallbackLng: 'en',
    supportedLngs: ['en', 'nl', 'de', 'uk'],
    debug: import.meta.env.DEV,
    detection: {
      order: ['localStorage', 'navigator'],
      caches: ['localStorage', 'cookie'],
    },
    interpolation: {
      escapeValue: false,
      format: value => {
        const newValue = value.toLowerCase();
        return newValue.charAt(0).toUpperCase() + newValue.slice(1);
      },
    },
  });

export default i18n;

export function setLanguageForLocalization(language) {
  i18n.changeLanguage(language);
}
